export enum PATH {
    MAIN = "/",
    CATALOGUES = "/catalogues",
    CATALOGUES_STAFF = "/catalogues/air_staff",
    CATALOGUES_BASES = "/catalogues/airbases",
    CATALOGUES_TRANSPORT = "/catalogues/avia_transport",
    CATALOGUES_CONTRACTORS = "/catalogues/contractors",
    CATALOGUES_CONTRACTS = "/catalogues/contracts",
    CATALOGUES_CONTRACT_AIRCRAFTS = "/catalogues/contract_aircrafts",
    CATALOGUES_CONTRACT_WORKS = "/catalogues/contract_works",
    CATALOGUES_WORKS = "/catalogues/works",
    REPORTS = "/reports",
    FLYGHTS = "/catalogues/flights",
    NOT_FOUND = "/404",
}
